import React, {
    useEffect,
    useState,
} from "react";

import {
    Flex,
    Box,
    Text,
    Badge,
} from "@chakra-ui/react";
import StatusBadge, {
    getStatusVariant,
} from "components/Badges/StatusBadge";
import {
    EllipsisVertical,
    Eye,
    Pencil,
    Users,
} from "lucide-react";

import { useDispatch, useSelector } from "react-redux";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import ReusableTable from "components/Tables/ReusableTable";
import ThreeDotMenu from "components/Menus/ThreeDotMenu";
import ReusableDrawer from "components/Drawers/ReusableDrawer";

import ViewDriverPartner from "./components/ViewDriverPartner";
import EditDriverPartnerDrawer from "./components/EditDriverPartnerDrawer";
import ReferredDriversDrawer from "./components/ReferredDriversDrawer";

import { useCustomNotification } from "components/Toasts/OpenNotification";

import {
    fetchDriverPartnersAction,
} from "state/actions/driverPartnerActions";

const DriverPartners = () => {
    const dispatch = useDispatch();

    const notify =
        useCustomNotification();

    const {
        driverPartners,
        loading,
        error,
        total,
    } = useSelector(
        (state) =>
            state.driverPartners
    );

    const [
        selectedPartner,
        setSelectedPartner,
    ] = useState(null);

    const [
        isViewOpen,
        setViewOpen,
    ] = useState(false);

    const [
        isEditOpen,
        setEditOpen,
    ] = useState(false);

    const [
    isDriversOpen,
    setDriversOpen,
] = useState(false);

const handleViewDrivers = (
    partner
) => {
    setSelectedPartner(partner);
    setDriversOpen(true);
};

    useEffect(() => {
        dispatch(
            fetchDriverPartnersAction()
        );
    }, [dispatch]);

    useEffect(() => {
        if (error) {
            notify({
                type: "error",
                message:
                    "Failed to load Driver Partners",
                description: error,
            });
        }
    }, [error]);

    const handleView = (
        partner
    ) => {
        setSelectedPartner(
            partner
        );
        setViewOpen(true);
    };

    const handleEdit = (
        partner
    ) => {
        setSelectedPartner(
            partner
        );
        setEditOpen(true);
    };

    const statusColor = {
        Approved: "green",
        Pending: "yellow",
        Suspended: "red",
        Rejected: "red",
        Deactivated: "gray",
    };

    const generateMenuItems = (
        row
    ) => [
        {
            icon: (
                <Eye size={16} />
            ),
            text: "View Partner",
            onClick: () =>
                handleView(
                    row.original
                ),
        },
         {
        icon: (
            <Users size={16} />
        ),
        text: "View Referred Drivers",
        onClick: () =>
            handleViewDrivers(
                row.original
            ),
    },
        {
            icon: (
                <Pencil
                    size={16}
                />
            ),
            text: "Update Status",
            onClick: () =>
                handleEdit(
                    row.original
                ),
        },
    ];

    const columnsData = [
        {
            Header:
                "Partner Name",
            accessor: (
                row
            ) =>
                `${
                    row.user
                        ?.first_name ||
                    ""
                } ${
                    row.user
                        ?.last_name ||
                    ""
                }`.trim() ||
                row.user
                    ?.username ||
                "N/A",
        },
        {
            Header: "Email",
            accessor: (
                row
            ) =>
                row.user
                    ?.email ||
                "N/A",
        },
        {
            Header: "Phone",
            accessor: (
                row
            ) =>
                row.user
                    ?.phone_number ||
                "N/A",
        },
        {
            Header:
                "Referral Code",
            accessor: (
                row
            ) =>
                row
                    .driver_partner
                    ?.partner_referral_code ||
                "N/A",
        },
        {
            Header:
                "Drivers",
            accessor: (
                row
            ) =>
                row
                    .stats
                    ?.total_referred_drivers
 ||
                "0",
        },
        {
    Header: "Status",
    accessor: (row) =>
        row.driver_partner?.status ||
        "Unknown",

    Cell: ({ value }) => (
        <StatusBadge
            label={value}
            variant={getStatusVariant(value)}
        />
    ),
},
        {
            Header:
                "Actions",
            accessor:
                "actions",
            Cell: ({
                row,
            }) => (
                <ThreeDotMenu
                    icon={
                        <EllipsisVertical
                            size={
                                18
                            }
                        />
                    }
                    items={generateMenuItems(
                        row
                    )}
                />
            ),
        },
    ];

    return (
        <Flex
            flexDirection="column"
            pt={{
                base: "120px",
                md: "25px",
            }}
        >
            <Box p={6}>
                <Flex justify="space-between">
                    <Text
                        fontSize="md"
                        fontWeight="bold"
                    >
                        {loading ? (
                            <Skeleton
                                width="150px"
                            />
                        ) : (
                            `Driver Partners: ${total}`
                        )}
                    </Text>
                </Flex>
            </Box>

            <ReusableTable
                columnsData={
                    columnsData
                }
                tableData={
                    Array.isArray(
                        driverPartners
                    )
                        ? driverPartners
                        : []
                }
                isLoading={
                    loading
                }
            />

            <ReusableDrawer
                isOpen={
                    isViewOpen
                }
                onClose={() =>
                    setViewOpen(
                        false
                    )
                }
                headerContent={
                    <h2>
                        Driver
                        Partner
                    </h2>
                }
                bodyContent={
                    selectedPartner && (
                        <ViewDriverPartner
                            partner={
                                selectedPartner
                            }
                            onClose={() =>
                                setViewOpen(
                                    false
                                )
                            }
                        />
                    )
                }
            />

            <EditDriverPartnerDrawer
                isOpen={
                    isEditOpen
                }
                onClose={() =>
                    setEditOpen(
                        false
                    )
                }
                partner={
                    selectedPartner
                }
            />
            <ReferredDriversDrawer
    isOpen={isDriversOpen}
    onClose={() =>
        setDriversOpen(false)
    }
    referralCode={
        selectedPartner
            ?.driver_partner
            ?.partner_referral_code
    }
/>
        </Flex>
    );
};

export default DriverPartners;